import { render, staticRenderFns } from "./CreateDesign.vue?vue&type=template&id=7212207c&scoped=true"
import script from "./CreateDesign.vue?vue&type=script&lang=js"
export * from "./CreateDesign.vue?vue&type=script&lang=js"
import style0 from "./CreateDesign.vue?vue&type=style&index=0&id=7212207c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7212207c",
  null
  
)

export default component.exports